import { useEffect, useState } from "react";
import { custApi } from "@/lib/api";
import { ShoppingCart, ArrowRight, Loader2, ShieldCheck } from "lucide-react";
import { hostBrand } from "@/lib/brand";

// Interstitial: tells the operator they're being taken to access.morrstore.com (the central
// MorrAccess login), then redirects. Only ever redirects to the backend-provided allowlisted host.
export default function SsoRedirect() {
  const [err, setErr] = useState("");
  const brand = hostBrand();

  useEffect(() => {
    let timer;
    custApi.get("/sso/login-url", { params: { app: hostBrand().key } })
      .then(({ data }) => {
        timer = setTimeout(() => { window.location.href = data.url; }, 1500);
      })
      .catch(() => setErr("We couldn't start the secure sign-in. Please try again."));
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-secondary flex items-center justify-center px-4" data-testid="sso-redirect">
      <div className="max-w-md w-full border border-border bg-card p-10 text-center">
        <div className="flex items-center justify-center gap-3 text-primary">
          <span className="inline-flex items-center gap-1.5 font-display font-extrabold tracking-tighter text-lg">
            <ShoppingCart className="h-5 w-5" /> {brand.name}
          </span>
          <ArrowRight className="h-4 w-4 text-muted-foreground" />
          <span className="inline-flex items-center gap-1.5 font-semibold text-lg">
            <ShieldCheck className="h-5 w-5" /> MorrAccess
          </span>
        </div>

        {err ? (
          <p className="mt-6 text-sm text-accent" data-testid="sso-redirect-error">{err}</p>
        ) : (
          <>
            <div className="mt-8 flex justify-center">
              <Loader2 className="h-7 w-7 animate-spin text-primary" />
            </div>
            <h1 className="mt-5 font-display font-bold text-xl">Taking you to sign in…</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              We're sending you to <b className="text-foreground">access.morrstore.com</b> — your central MorrAccess login for {brand.name}. You'll be brought right back once you're signed in.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
